import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { PadraoService } from "src/app/service/padrao/padrao.service";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ToasterService } from "angular2-toaster";
import { ProcessoAtivoDTO } from "../../pages/solicitacao-dilatacao/dto/processo-ativo";
import { SolicitacaoDTO } from "./dto/solicitacao";
import { ConfirmacaoSolicitacaoDialogComponent } from "./confirmacao-solicitacao-dialog/confirmacao-solicitacao-dialog.component";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { SuccessDialogComponent } from "./../../components/dialog/success-dialog/success-dialog.component";
import { ErrorDialogComponent } from "./../../components/dialog/error-dialog/error-dialog.component";
import { isValidCpf } from "src/app/utils/CpfValidator";
import { ConsultaCepService } from "src/app/service/consulta-cep/consulta-cep.service";
import { MaskUtil } from "../util/mask-util";
import { EnderecoResponse } from "src/app/responses/endereco-response";
import { MessageService } from "src/app/core/message.service";
import { DocUploadComponent } from "src/app/components/doc-upload/doc-upload.component";

@Component({
  selector: "app-solicitacao-dilatacao",
  templateUrl: "./solicitacao-dilatacao.component.html",
  styleUrls: ["./solicitacao-dilatacao.component.css"],
  providers: [PadraoService],
})
export class SolicitacaoDilatacaoComponent implements OnInit {
  registerForm: FormGroup;
  captchaForm: FormGroup;
  recaptcha: ReCaptchaV3Service;
  telMask: string;
  submitted = false;
  @BlockUI() loading: NgBlockUI;
  processoInvalido: boolean;
  processoAtivo: ProcessoAtivoDTO;
  buscaCepDone: boolean = true;
  semNumeroChecked: boolean;

  @ViewChild("arquivoList")
  arquivoList: DocUploadComponent;

  constructor(
    private formBuilder: FormBuilder,
    private padraoService: PadraoService,
    private toast: ToasterService,
    public dialog: MatDialog,
    private consultaCepService: ConsultaCepService,
    private message: MessageService
  ) {}

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      nomeCompleto: ["", Validators.required],
      numeroCpf: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(11),
          isValidCpf(),
        ]),
      ],
      email: ["", Validators.required],
      numeroTelefone: ["", [Validators.required, Validators.minLength(10)]],
      numeroProcesso: ["", [Validators.required, Validators.minLength(20)]],
      detalhe: ["", Validators.required],
      cep: ["", [Validators.required, Validators.maxLength(10)]],
      uf: ["", [Validators.required, Validators.maxLength(2)]],
      cidade: ["", [Validators.required]],
      bairro: ["", [Validators.required]],
      rua: ["", [Validators.required]],
      complemento: [""],
      numero: ["", [Validators.required, Validators.maxLength(10)]],
      enderecoSigiloso: new FormControl(false),
      checkedSemNumero: new FormControl(false),
    });

    this.registerForm
      .get("numeroTelefone")
      .valueChanges.map((valor) => valor)
      .subscribe((length) => {
        if (length < 11) {
          this.telMask = "(00) 0000-00000";
        } else {
          this.telMask = "(00) 00000-0000";
        }
      });

    this.registerForm.get("email").valueChanges.subscribe((event) => {
      this.registerForm
        .get("email")
        .setValue(event.toLowerCase(), { emitEvent: false });
    });
  }

  get f() {
    return this.registerForm.controls;
  }

  public removerEspaco(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) =>
      formGroup.get(key).setValue(formGroup.get(key).value.trim())
    );
  }

  limparForm() {
    this.ngOnInit();
    window.scroll(0, 0);
  }

  buscarPorNumeroProcesso(numeroProcesso: string) {
    numeroProcesso = numeroProcesso.replace(/\D+/g, "");
    this.loading.start(
      "Estamos consultando seu processo. Aguarde um momento..."
    );
    this.padraoService.buscarPorNumeroProcesso(numeroProcesso).subscribe(
      (response) => {
        this.processoAtivo = response;
        this.processoInvalido = true;
        this.toast.pop("success", "Número do processo encontrado.");
        this.loading.stop();
      },
      (error) => {
        this.processoInvalido = false;
        this.registerForm.get("numeroProcesso").setErrors({ incorrect: true });
        this.toast.pop(
          "warning",
          "Processo não encontrado.",
          "Número do processo não encontrado. Por favor tente novamente."
        );
        this.loading.stop();
      }
    );
  }

  openDialog(): void {
    let solicitacao = new SolicitacaoDTO();
    solicitacao.nome = this.registerForm.controls.nomeCompleto.value;
    solicitacao.cpf = this.registerForm.controls.numeroCpf.value;
    solicitacao.emailSolicitante = this.registerForm.controls.email.value;
    solicitacao.telefone = this.registerForm.controls.numeroTelefone.value;
    solicitacao.numeroProcesso =
      this.registerForm.controls.numeroProcesso.value;
    solicitacao.nomeDaVara = this.processoAtivo.nomeDaVara;
    solicitacao.codigoDaVara = this.processoAtivo.codigoCnjVara;
    solicitacao.emailDaVara = this.processoAtivo.emailDaVara;
    solicitacao.nomeDaComarca = this.processoAtivo.nomeDaComarca;
    solicitacao.codigoDaComarca = this.processoAtivo.codigoCnjComarca;
    solicitacao.detalheSolicitacao = this.registerForm.controls.detalhe.value;
    solicitacao.cep = this.registerForm.controls.cep.value;
    solicitacao.uf = this.registerForm.controls.uf.value;
    solicitacao.cidade = this.registerForm.controls.cidade.value;
    solicitacao.bairro = this.registerForm.controls.bairro.value;
    solicitacao.rua = this.registerForm.controls.rua.value;
    solicitacao.complemento = this.registerForm.controls.complemento.value;
    solicitacao.numero = this.registerForm.controls.numero.value;
    solicitacao.enderecoSigiloso =
      this.registerForm.controls.enderecoSigiloso.value;

    const formData = this.construirAnexo(solicitacao);

    const dialogRef = this.dialog.open(ConfirmacaoSolicitacaoDialogComponent, {
      width: "800px",
      data: {formData, solicitacao},
      disableClose: true,
      autoFocus: true,
    });

    dialogRef.afterClosed().subscribe(
      (response) => {
        if (response != undefined && response != null) {
          this.abrirRespostaSucesso(response);
          this.limparForm();
        }
      },
      (error) => {
        this.abrirRespostaErro("Falha ao abrir solicitação.\n" + error);
      }
    );
  }

  construirAnexo(solicitacao: SolicitacaoDTO) {
    const { listaDocumentos } = this.arquivoList;
    const formData = new FormData();
    formData.set("solicitacaoFormData", "solicitacao_anexo");    
    listaDocumentos.forEach(({ nome, extensao, arquivo }) => {
      formData.append("nomes", nome);
      formData.append("extensoes", extensao);
      formData.append("files", arquivo, arquivo["name"]);
    });
    formData.append('solicitacao', new Blob([JSON
        .stringify(solicitacao)], {
        type: 'application/json'
      }));

      return formData;


  }

  abrirRespostaSucesso(solicitacao: SolicitacaoDTO) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { solicitacao: solicitacao };
    dialogConfig.width = "600px";
    dialogConfig.height = "380px";
    dialogConfig.panelClass = "custom-dialog";
    this.dialog.open(SuccessDialogComponent, dialogConfig);
  }

  abrirRespostaErro(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = "600px";
    dialogConfig.height = "380px";
    this.dialog.open(ErrorDialogComponent, dialogConfig);
  }

  onCepChange() {
    const { cep } = this.registerForm.value;
    this.buscaCepDone = false;
    if (cep && MaskUtil.onlyNumbers(cep).length === 8) {
      this.consultaCepService.consultaCep(cep).subscribe({
        next: (res: EnderecoResponse) => {
          this.registerForm.patchValue({
            rua: res.logradouro,
            complemento: res.complemento,
            bairro: res.bairro,
            uf: res.uf,
            cidade: res.localidade,
          });
          this.buscaCepDone = true;
        },
        error: (er) => {
          this.message.sendMessage(
            "Sistema de Medida Protetiva",
            `CEP ${MaskUtil.cepToMask(cep)} não encontrado.`
          );

          this.registerForm.patchValue({
            cep: null,
            rua: "",
            complemento: "",
            bairro: "",
            uf: "",
            cidade: "",
          });
        },
      });
    } else {
      this.registerForm.patchValue({
        cep: null,
      });
    }
  }

  onChangeCheckedSN() {
    this.semNumeroChecked = !this.semNumeroChecked;

    if (this.semNumeroChecked) {
      this.registerForm.controls["numero"].disable();
      this.registerForm.controls["numero"].setValue("");
      this.registerForm.controls["numero"].clearValidators();
    } else {
      this.registerForm.controls["numero"].enable();
      this.registerForm.controls["numero"].setValidators(Validators.required);
      this.registerForm.controls["numero"].setValue("");
    }
  }

}